<div
  class="initials-container"
  [ngClass]="{'icon-inverted-colors': theme === initialsTheme.Dark, 'icon-default-colors': theme === initialsTheme.Light}"
>
  {{initials}}
</div>

